import { getRandomUUID } from 'shared/lib/core/lib/utils';
import { useCallback, useEffect, useRef, useState } from 'react';
import { CustomError } from 'shared/api';
import { isRejectedWithValue, PayloadAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { showError } from 'shared/lib/asyncActionFeedback';
import { PostOrderResponce } from 'entities/orders/model/types';

interface UseBookingAwaitByTimerParams {
	bookOrEdit: () => Promise<
		PayloadAction<PostOrderResponce | CustomError | undefined>
	>;
	removeRestrictions: () => void;
	setToastAwaitId: (id: number) => void;
	onSuccessBookingActions: () => void;
	onErrorBookingActions: (errors: string) => void;
	toastAwaitId: number | string;
	idempotencyKeyRef: React.MutableRefObject<`${string}-${string}-${string}-${string}-${string}` | string>
}

export const useBookingAwaitByTimer = ({
	bookOrEdit,
	removeRestrictions,
	setToastAwaitId,
	onSuccessBookingActions,
	onErrorBookingActions,
	toastAwaitId,
	idempotencyKeyRef
}: UseBookingAwaitByTimerParams) => {
  const [isEffect, setIsEffect] = useState<boolean>(false);
  const counter = useRef<number>(0);

	const handleBookingStatusCheck = useCallback(
		async (intervalId?: NodeJS.Timeout) => {
      console.log('Попытка создания бронирования номер ' + counter.current);

      counter.current++;
			const result = await bookOrEdit();

			if (isRejectedWithValue(result)) {
				showError(result.payload as CustomError);
				removeRestrictions();
				return;
			}

			const response = result.payload as PostOrderResponce;
			const responseStatus = response?.status;
			if (responseStatus) {
				toast.dismiss(toastAwaitId);
				clearInterval(intervalId);
				setToastAwaitId(0);

				if (responseStatus === 1) {
          setIsEffect(false);
					return onSuccessBookingActions();
				} else if (responseStatus === 99) {
          setIsEffect(false);
					idempotencyKeyRef.current = crypto?.randomUUID ? crypto.randomUUID() : getRandomUUID();
					return onErrorBookingActions(response?.errors);
				}
			}

      clearTimeout(intervalId);

      if (counter.current < 10) {
        intervalId = setTimeout(() => {
          handleBookingStatusCheck(intervalId);
        }, 1000);
      } else {
        setIsEffect(false);
        counter.current = 0;
				toast.dismiss(toastAwaitId);
        return onErrorBookingActions('Ошибка!');
      }
		},
		[
			toastAwaitId,
			bookOrEdit,
			removeRestrictions,
			onSuccessBookingActions,
			onErrorBookingActions,
			setToastAwaitId,
			idempotencyKeyRef
		],
	);

	useEffect(() => {
		if (toastAwaitId) {
      console.log('toastAwaitId', toastAwaitId);
      if (!isEffect) {
        setIsEffect(true);
        handleBookingStatusCheck()
      }
      // let intervalId: NodeJS.Timeout;
      // intervalId = setInterval(async () => {
      //   await handleBookingStatusCheck(intervalId);
      // }, 1000);

			// return () => clearInterval(intervalId);
		}
		// eslint-disable-next-line
	}, [toastAwaitId]);
};
